// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"lZ","cardInnerHeading":"l0","toggleWrapperClass":"l1","changeProfile":"l2 l1","textWrapperClass":"l3","toggleTextClass":"l4","warningMessage":"l5"};